import SearchField from "modules/Analytics/Shared/SearchField";
import React from "react";
import styled from "styled-components";
import ExportAnalyticsPopup from "../Shared/ExportAnalyticsPopup";
import ContentList from "./ContentList";

interface IAnalyticsContent {
  setSearchedText: (value: string) => void;
  searchedText: string;
}
const AnalyticsContent: React.FC<IAnalyticsContent> = (props: IAnalyticsContent) => {
  const { searchedText, setSearchedText } = props;

  return (
    <Wrapper>
      <div className="search-field-container">
        <span className="content-text">Ranked Content:</span>
        <div className="scaled-width-35">
          <SearchField placeholder="Search ..." handleSearch={setSearchedText} reset={searchedText}></SearchField>
        </div>
      </div>
      <ContentList searchedText={searchedText} setSearchedText={setSearchedText} />
      <ExportAnalyticsPopup page={"content"} searchedText={searchedText} />
    </Wrapper>
  );
};

export default AnalyticsContent;

const Wrapper = styled.div`
  .search-field-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .search-bar {
    height: 34px !important;
    display: flex !important;
    align-items: center;
  }
  .search-input {
    margin-top: 0 !important;
  }
  .content-text {
    font-size: 23px;
    line-height: 47px;
    color: #424b50;
    font-weight: 400;
    font-family: "Roboto Slab";
  }
  .scaled-width-35 {
    width: 200px;
  }
`;
